import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1833871f")

_pushScopeId("data-v-1833871f")
const _hoisted_1 = { class: "progress" }
const _hoisted_2 = { class: "progress-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "progress-value",
      style: { width: $props.value + '%' }
    }, null, 4),
    _createVNode("div", _hoisted_2, "Total Coverage: " + _toDisplayString($props.value) + "%", 1)
  ]))
})